import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ReportsService} from '../shared/services/reports.service';
import {ReportType} from '../shared/domain/report/report-type.enum';
import {ReportDataSource} from '../shared/domain/report/report-data-source.enum';
import {ReportDimension} from '../shared/domain/report/report-dimension.enum';
import {ReportMetric} from '../shared/domain/report/report-metric.enum';
import {ReportRequest} from '../shared/domain/report/report-request.model';
import {ReportGrouping} from '../shared/domain/report/report-grouping.enum';

@Injectable()
export class KitchenDashboardService {

  constructor(private httpClient: HttpClient,
              private reportsService: ReportsService) {
  }

  getDashData(dateFrom, dateTo, publisherIds: string[] = []) {
    return this.reportsService.report(<ReportRequest>{
      reportGrouping: ReportGrouping.BY_SINGLE_DIMENSION,
      reportType: ReportType.FINANCIAL,
      dataSource: ReportDataSource.DATE_PERIOD_DEPENDENT,
      dimensions: [
        ReportDimension.AD_UNIT,
        ReportDimension.PUBLISHER,
      ],
      metrics: [
        ReportMetric.AD_UNIT,
        ReportMetric.IMPRESSIONS,
        ReportMetric.AD_REQUESTS,
        ReportMetric.FILLED,
        ReportMetric.REFRESH_RATE,
        ReportMetric.RPM,
        ReportMetric.IO_CPM,
        ReportMetric.MARGIN,
        ReportMetric.REVENUE,
        ReportMetric.PUBLISHER_REVENUE,
        ReportMetric.PROFIT,
        ReportMetric.ACCOUNT_REPRESENTATIVE_EMAIL,
        ReportMetric.USING_CONFIANT,
        ReportMetric.EB_ASSOCIATED_PUBLISHER_NAME,
      ],
      filters: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        adUnitIds: [],
        mergeCompanionUnits: true,
        excludeDfpSourceBidderRevenue: true,
        publisherIds: publisherIds || [],
        demandPartnerIds: [],
        activityStatuses: [],
        siteIds: [],
        domainIds: [],
        widgets: [],
      },
      predicates: [],
    });

  }


}
